import { INLINES } from '@contentful/rich-text-types'
import { css } from '@emotion/react'
import { Block } from 'components/Block'
import { SHeroImageWrapper } from './AboutHero.styled'
import { ContentfulContent } from 'components/content/contentfulContent/ContentfulContent'
import { ContentfulImage } from 'components/Image'
import { PrimaryLink } from 'components/Link'
import { Caption, Text, Title, Title_h2_default } from 'components/Typography'
import { useContentfulImages } from 'utils/contentful/ContentfulImagesContext'
import { useWindowSize } from 'utils/hooks'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export function AboutHero({
  className,
  content,
}: {
  className?: string
  content: {
    aboutHeroTitle?: string
    aboutHeroDescription?: string
    aboutHeroCaption?: string
  }
}) {
  const images = useContentfulImages()
  const { isDesktop } = useWindowSize()

  return (
    <Block className={className}>
      <div
        css={css`
          position: relative;
          overflow: hidden;
          margin-left: var(--p-content);

          display: flex;
          align-items: center;

          min-height: ${pxToRem(720)}rem;

          @media ${BREAKPOINTS.MD.max} {
            flex-direction: column-reverse;
            align-items: flex-end;
            justify-content: flex-start;
            min-height: unset;
            height: auto;

            margin-bottom: 3rem;
          }
        `}
      >
        <div
          css={css`
            padding-right: 4.4375rem;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: calc(50% - 5.625rem);

            position: relative;

            &:before {
              content: '';
              border: 2px solid var(--c-blue100);
              position: absolute;
              z-index: -1;
              top: -1.6875rem;
              left: 1.75rem;
              right: -2.875rem;
              bottom: -2.5rem;

              @media ${BREAKPOINTS.MD.max} {
                display: none;
              }
            }

            @media ${BREAKPOINTS.LG.max} {
              width: calc(60% - 5.625rem);
            }

            @media ${BREAKPOINTS.MD.max} {
              width: 100%;
              padding-right: calc(5% * (100 / 95));
            }
          `}
        >
          <Caption
            css={css`
              color: var(--c-blue500);
              margin-bottom: 1.1875rem;
            `}
          >
            {content.aboutHeroCaption}
          </Caption>

          <Title variant={Title_h2_default} css={{ marginBottom: '1.1875rem' }}>
            {content.aboutHeroTitle}
          </Title>

          {typeof content.aboutHeroDescription === 'string' ? (
            <Text>{content.aboutHeroDescription}</Text>
          ) : (
            <ContentfulContent
              data={content.aboutHeroDescription}
              components={{ [INLINES.HYPERLINK]: <PrimaryLink /> }}
            />
          )}
        </div>

        <SHeroImageWrapper>
          <ContentfulImage {...(isDesktop ? images.about_us_hero : images.about_us_hero_mobile)} />
        </SHeroImageWrapper>
      </div>
    </Block>
  )
}
